import React from 'react'


function LeftSection({ imageURL, productName, productDescription, tryDemo, learnMore, googlePlay, appStore }) {
    return (
        <div className='continer'>
            <div className='row' style={{ paddingInline: "210px"}}>
                <div className='col-6'>
                    <img src={imageURL} alt='img'/>
                </div>
                <div className='col-6' style={{ padding: "100px"}}>
                    <h1>{productName}</h1>
                    <p>{productDescription}</p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem'}}>
                        <div style={{ display: 'flex', gap: '2rem' }}>
                            <a style={{ textDecoration: 'none' }} href={tryDemo}>Try Demo →</a>
                            <a style={{ textDecoration: 'none' }} href={learnMore}>Learn More →</a>
                        </div>
                        <div style={{ display: 'flex', gap: '2rem' }}>
                            <a href={googlePlay}><img src="media/googlePlayBadge.svg" /></a>
                            <a href={appStore}><img src="media/appstoreBadge.svg" /></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LeftSection;